import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TemplateByLanguageDTO } from "app/data/schema/Communication/TemplateByLanguageDTO";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { MessageLogDTO } from "../../schema/Communication/MessageLogDTO";
import { MessageLogFiltersDTO } from "../../schema/Communication/MessageLogFiltersDTO";

@Injectable({
    providedIn: "root"
})
export class MessageLogService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.communication.url}/api/MessageLog`;
    }

    list(filter: MessageLogFiltersDTO): Observable<GetDataDTO<MessageLogDTO>> {
        let params = new HttpParams()
            .set("skip", filter.skip.toString())
            .set("take", filter.take.toString())
            .set("sortOrder", filter.sortOrder.toString())
            .set("orderBy", filter.orderBy.toString());

        if (filter.find != null) params = params.set("find", filter.find);
        if (filter.userId != null) params = params.set("userId", filter.userId);
        if (filter.onlyNotSent != null) params = params.set("onlyNotSent", filter.onlyNotSent.toString());
        filter.types?.forEach((t) => (params = params.append("types", t)));

        return this.httpClient.get<GetDataDTO<MessageLogDTO>>(`${this.relativePath}`, { params });
    }

    markMessageAsSent(id: string): Observable<any> {
        return this.httpClient.post(`${this.relativePath}/${id}/MarkAsSent`, null);
    }
    
    getMessageBody(id: string, language: string): Observable<TemplateByLanguageDTO> {
        return this.httpClient.get<TemplateByLanguageDTO>(`${this.relativePath}/${id}/body/${language}`);
    }
}
